import type { TableColumn, TableRow } from "../../types/domain";
import { StatusPill } from "./StatusPill";

type DataTableProps = {
  columns: TableColumn[];
  rows: TableRow[];
  caption?: string;
};

export function DataTable({ columns, rows, caption }: DataTableProps) {
  return (
    <div className="admin-table-wrap" role="region" aria-label={caption ?? "Bảng dữ liệu"}>
      <table className="admin-table">
        {caption ? <caption>{caption}</caption> : null}
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} className={column.align ? `align-${column.align}` : undefined}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={`${row.code ?? rowIndex}`}>
              {columns.map((column) => {
                const value = String(row[column.key] ?? "");
                return (
                  <td key={column.key} className={column.align ? `align-${column.align}` : undefined}>
                    {column.key === "status" ? <StatusPill>{value}</StatusPill> : value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
